import AppearanceItems from './AppearanceItems';

interface AccountMenuItemsProps {
  /** Called before navigating away, so a drawer can dismiss. Unused while
   *  appearance is the only row, and kept because every consumer passes it and
   *  the next row that navigates will need it. */
  onNavigate: () => void;
}

/** The account actions, minus the identity line and Sign out — those two are
 *  placed differently by each consumer. Kept as one component so the nav panel
 *  and the mobile drawer offer the same actions in the same order.
 *
 *  Switching what you are looking at is no longer one of them: the mode switch
 *  lives in the top and mobile bars, which teacher mode also has, whereas this
 *  block only renders where there is a nav to hang it off.
 *
 *  Settings is deliberately absent too: it is pinned to the nav footer beside
 *  Sign out, and listing it here put it on screen twice. */
export default function AccountMenuItems({ onNavigate: _onNavigate }: AccountMenuItemsProps) {
  return <AppearanceItems />;
}
